export const getIconFromURL = (url: string, sizeIcon: number) => {
    if (url.includes('g.co')) {
        url = 'https://google.com';
    }
    return `https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${url}/&size=${sizeIcon}`;
};
